"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Factory = _interopRequireDefault(require("./Factory"));
var _EmptyDelegate = _interopRequireDefault(require("./EmptyDelegate"));
var _Namespaced = _interopRequireDefault(require("./Namespaced"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * This is acting as the "static" interface being the libray user and the 
 * delegate. Most of these calls simple pass through to the delegate, or manage
 * the delegate itself
 */
class I18N {
  constructor() {
    this.delegate = new _EmptyDelegate.default();
    this.iconDelegates = [];
  }
  async init(config) {
    const delegateCreator = _Factory.default.create(config);
    this.delegate = await delegateCreator.init(config);
    return this;
  }
  setDelegate(del) {
    this.delegate = del || new _EmptyDelegate.default();
  }
  getDelegate() {
    return this.delegate;
  }
  addIconDelegate(del) {
    if (!this.iconDelegates.includes(del)) {
      this.iconDelegates.push(del);
    }
  }
  removeIconDelegate(del) {
    const idx = this.iconDelegates.indexOf(del);
    if (idx >= 0) {
      this.iconDelegates.splice(idx);
    }
  }

  /**
   * Creates an object with a t() and tIcon() function that will automatically
   * append the namespace to the key
   * @param {String} namespace The namespace to append to every key
   * @param {String} separator The separator between the namespace and key. Default to '.'
   * @returns 
   */
  ns = (namespace, separator = '.') => {
    return new _Namespaced.default(namespace, this, separator);
  };
  exists = (...args) => {
    return this.delegate.exists(...args);
  };
  t = (...args) => {
    const r = this.delegate.t(...args);
    if (isRedirect(r)) {
      const rr = redirectT(new Set(), false, r, this, ...args);
      return rr;
    }
    return r;
  };
  tArray = (...args) => {
    const v = this.t(...args);
    if (Array.isArray(v)) {
      return v;
    }
    return Array.isArray(args[1]) ? args[1] : null;
  };
  tIcon = (...args) => {
    // eslint-disable-next-line security/detect-non-literal-fs-filename
    if (this.delegate.exists(args[0])) {
      const r = this.delegate.t(...args);
      if (isRedirect(r)) {
        const rr = redirectT(new Set(), true, r, this, ...args);
        return rr;
      }
      return r;
    }
    return this.getFromIconDelegates(...args);
  };
  tIconArray = (...args) => {
    const v = this.t(...args);
    if (Array.isArray(v)) {
      return v.map(r => {
        if (isRedirect(r)) {
          const rr = redirectT(new Set(), true, r, this, ...args);
          return rr;
        }
        return r;
      });
    }
    return Array.isArray(args[1]) ? args[1] : null;
  };
  tf = (...args) => {
    return () => this.t(...args);
  };
  tfIcon = (...args) => {
    return () => this.tIcon(...args);
  };
  tfArray = (...args) => {
    return () => this.tArray(...args);
  };
  tfIconArray = (...args) => {
    return () => this.tIconArray(...args);
  };
  getFromIconDelegates = (...args) => {
    for (let n = 0; n < this.iconDelegates.length; n++) {
      const v = this.iconDelegates[n].getIcon(...args);
      if (!(v === undefined || v === false)) {
        return v;
      }
    }
    return args[1] === null || typeof args[1] === 'string' ? args[1] : null; // args[0]
  };
}
exports.default = I18N;
function isRedirect(r) {
  return r && r.type === 'redirect' && r.key;
}
function redirectT(visited, isIcon, red, i18n, ...args) {
  visited.add(args[0]);
  if (visited.has(red.key)) {
    // already tried
    return (isIcon ? i18n.getFromIconDelegates(...args) : null) || red.fallback;
  }
  if (isIcon) {
    const icon = i18n.getFromIconDelegates(args[0]);
    if (icon) {
      return icon;
    }
  }

  // add the new key location
  const nArgs = [...args];
  nArgs[0] = red.key;
  if (i18n.delegate.exists(...nArgs)) {
    const result = i18n.delegate.t(...nArgs);
    if (isRedirect(result)) {
      return redirectT(visited, isIcon, result, i18n, nArgs) || red.fallback;
    }
    return result;
  }
  return (isIcon ? i18n.getFromIconDelegates(nArgs[0]) : null) || red.fallback;
}